export function isImage(mimeType: string) {
  return /image\/*/.test(mimeType);
}
